import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {useContext} from 'react';

import {useReviewsAnalysisFilter} from '../../../page/main/reviews-analysis/reviews-analysis-hook';
import {MainFilterContext} from '../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../provider/main-filter/main-filter-type';

import {fetchCompetitorsByAspect} from './review-competitors-by-aspect-api';
import {CompetitorByAspectPointType} from './review-competitors-by-aspect-type';

// BST-10541: single-aspect page — competitor tonality/mentions for one aspect.
export function useCompetitorsByAspect(aspectId: number): UseQueryResult<Array<CompetitorByAspectPointType>> {
    const {competitorFilter} = useReviewsAnalysisFilter();
    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    return useQuery(
        ['competitors-by-aspect', aspectId, competitorFilter, mainFilterKey],
        () => fetchCompetitorsByAspect(competitorFilter, aspectId, mainFilterKey),
        {
            refetchOnWindowFocus: false,
            refetchInterval: false,
        }
    );
}
